import { render } from "./report.vue?vue&type=template&id=135d7cdc&scoped=true&ts=true"
import script from "./report.vue?vue&type=script&lang=ts"
export * from "./report.vue?vue&type=script&lang=ts"

import "./report.vue?vue&type=style&index=0&id=135d7cdc&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135d7cdc"]])

export default __exports__